import React,{useState,useEffect} from 'react'
import { PayPalScriptProvider, PayPalButtons,usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { getPaypalClientId, salesforceSendFormNumber } from '../../actions/StudentAction';
// import PaypalExpressBtn from 'react-paypal-express-checkout';
import ReactLoading from 'react-loading';
import { useNavigate } from 'react-router-dom';

import { uploadPaymentStatus } from '../../actions/StudentAction';
import PaypalButtonWrapper from './PaypalButtonWrapper'
import swal from 'sweetalert';
import axios from 'axios';
import { countryId } from '../../config/Constant';


const Paypal = (props) => {
  const navigate = useNavigate()
  const[paypalClientId,setPaypalClientId] = useState({});
  // const [loading, setLoading] = useState(props.loading)
  // console.log('loading...',props.loading)
  // setLoading(true)
    const detail=props.detail
    const feeDetail=props.feeDetail
    const payType=props.payType
    const paymentConfig = props.paymentConfig
    const currency=paymentConfig.currency?paymentConfig.currency:'AED'
 
    const saveResponse = async (data)=>{
      props.setLoader(true)
                uploadPaymentStatus(data).then(res => {
                if(res.status){
                  props.setLoader(false)
                    swal(res.message?res.message:'Thank You for your payment Your fee has been submitted successfully.','','success');
                    // window.location.reload(true);
                    salesforceSendFormNumber(detail.form_num!==undefined && detail.form_num).then((res) => {
                      console.log('ress....',res)
                    })
                    navigate('/dashboard', {state : {detail:detail}})
                }
                else{
                  swal(`Payment Failed! We couldn't process your payment. Please Try Again
                  Don't worry your money is safe! If amount was debited from your account, it will be refunded automatically in 5-7 working days`,'','error');
                }
            })

    }
    return (
    // ASgkKk_-HFroW9Uytamqouc413g1Iod3wELMf9dyfnirQHtknr7KsQ_UxTFGMAkSXnSepgt8XenfkPep
    // "AX01eb2EwS1hRHxx9qwyNSM9tc1Zgo76PLRscinBm2f8-UABs9iySrw3yHWCBjaluP6dJ-b1c4aq5cG9"


    <PayPalScriptProvider options={{ "client-id":`${paymentConfig.client_id}` ,components: "buttons",
    currency:`${paymentConfig.currency}`, "disable-funding":"card"}}>
          <PaypalButtonWrapper 
          detail={detail} 
          feeDetail={feeDetail}
          showSpinner={true}
          currency={currency}
          payType={payType}
          onSubmit={saveResponse}
        />
        </PayPalScriptProvider>

      
  )
}

export default Paypal
